// Handles general properties of the metaGame that isn't saved
// via the API (eg, loading state)

import gameIds from '../data/GameIds';
import { SEASON } from '../data/constants';
import { persistStateTypes } from '../../reducers/persistStateReducer';

const initialState = {
  version: 1,
  loading: true,
  screenParams: {},
  navigation: {
    category: undefined,
    screen: 'Loading',
  },
  currentQuest: {
    location: undefined,
    questNumberIndex: undefined,
  },
  gameLaunchedFrom: {
    location: undefined,
    categoryId: '',
    questId: undefined,
  },
  isDemoSelectorShown: false,
  isDemoToolbarShown: false,
  isQuestInDemoMode: false,
};

const metaGameReducer = (state = initialState, action) => {
  if (action.gameId !== gameIds.METAGAME) {
    return state;
  }
  switch (action.type) {
    case 'GO_TO_QUEST':
      return {
        ...state,
        navigation: {
          screen: action.payload.isNewQuest ? `${action.payload.location}Quest${action.payload.questNumberIndex}`
            : 'Quest',
        },
        currentQuest: {
          location: action.payload.location,
          questNumberIndex: action.payload.questNumberIndex,
        },
      };
    case 'SET_QUEST':
      return {
        ...state,
        navigation: {
          screen: action.payload.isNewQuest ? `${action.payload.location}Quest` : 'Quest',
        },
        currentQuest: {
          location: action.payload.location,
          questNumberIndex: action.payload.questNumberIndex,
        },
      };
    case 'SELECT_HUB_SCREEN':
      return {
        ...state,
        navigation: {
          category: action.payload.categoryName,
          screen: action.payload.screenName,
        },
        screenParams: action.payload.screenParams,
      };
    case persistStateTypes.REQUEST_GAMESTATE_ALL:
    case persistStateTypes.REQUEST_GAMESTATE:
      return {
        ...state,
        loading: true,
      };
    case persistStateTypes.POSTRESPONSE_GAMESTATE:
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
    case persistStateTypes.REQUESTERROR_GAMESTATE:
    case persistStateTypes.REQUESTERROR_GAMESTATE_ALL:
      return {
        ...state,
        loading: false,
      };
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE_ALL: {
      let isQuestInDemoMode = false;
      const { demoSeason } = (action.stateData[gameIds.TEACHER_DASHBOARD_SETTINGS] || {}).GameData || {};
      if ([SEASON.GRADE_K_1, SEASON.GRADE_2_3, SEASON.GRADE_4_5].includes(demoSeason)) {
        isQuestInDemoMode = true;
      }
      return {
        ...state,
        loading: false,
        isDemoToolbarShown: isQuestInDemoMode,
        isQuestInDemoMode,
      };
    }
    case 'SET_GAME_LAUNCHED_FROM':
      return {
        ...state,
        gameLaunchedFrom: action.payload,
      };
    case 'SHOW_DEMO_SELECTOR':
      return {
        ...state,
        isDemoToolbarShown: false,
        isDemoSelectorShown: true,
      };
    case 'HIDE_DEMO_SELECTOR':
      return {
        ...state,
        isDemoToolbarShown: true,
        isDemoSelectorShown: false,
      };
    case 'SHOW_DEMO_TOOLBAR':
      return {
        ...state,
        isDemoToolbarShown: true,
      };
    case 'HIDE_DEMO_TOOLBAR':
      return {
        ...state,
        isDemoToolbarShown: false,
      };
    default:
      return state;
  }
};

export default metaGameReducer;
